import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r4: FaireReviewEntity = {
  token: "review_r4",
  type: "review",
  brandName: "ROEN",
  reviewerName: "Michael K.",
  reviewerLocation: "Denver, CO",
  stars: 5,
  reviewText:
    "A staple in my shop. The burn time is excellent and customers frequently repurchase. Highly recommend for any home goods store.",
  reviewDate: "Dec 10, 2025",
  reviewType: "brand",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
    "https://cdn.prerelease.faire.dev/fastly/56884e66685193058ffed10b4132877eba11d2a0013a35e2fa68ec6fad9c8ed6.webp",
  ],
  productImageUrl:
    "https://images.unsplash.com/photo-1608181831718-2501766a7e86?w=80&h=80&fit=crop",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
